/**
 * ============================================================================
 * USER / TENANT PAGE: Customer Contacts & Audience Groups (Sheets 25 & 28)
 * ============================================================================
 * Purpose:
 *   Tenant workspace interface for managing customer address books, audience
 *   groups, phone numbers, and segmentation tags.
 *
 * Database Scope:
 *   Tenant Database (`digi_user_<id>`)
 * ============================================================================
 */

import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { UsersIcon } from "@heroicons/react/24/outline";
import ContactTab from "./ContactTab";
import GroupTab from "./GroupTab";

export default function ContactManagement({ defaultTab = "contacts" }) {
  const [searchParams, setSearchParams] = useSearchParams();
  const urlTab = searchParams.get("tab");
  const [activeTab, setActiveTab] = useState(urlTab || defaultTab || "contacts");

  useEffect(() => {
    if (urlTab && (urlTab === "contacts" || urlTab === "groups")) {
      setActiveTab(urlTab);
    }
  }, [urlTab]);

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setSearchParams({ tab });
  };

  return (
    <div className="space-y-6 max-w-7xl mx-auto pb-12">
      {/* Top Banner */}
     

      {/* Tabs */}
      <div className="flex space-x-2 border-b border-black/5 dark:border-white/10 pb-2">
        <button
          onClick={() => handleTabChange("contacts")}
          className={`px-4 py-2 text-xs font-semibold rounded-xl transition-all cursor-pointer ${
            activeTab === "contacts"
              ? "bg-[#007AFF] text-white shadow-sm"
              : "text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800"
          }`}
        >
          👥 Contacts List
        </button>
        <button
          onClick={() => handleTabChange("groups")}
          className={`px-4 py-2 text-xs font-semibold rounded-xl transition-all cursor-pointer ${
            activeTab === "groups"
              ? "bg-[#007AFF] text-white shadow-sm"
              : "text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800"
          }`}
        >
          🏷️ Audience Groups
        </button>
      </div>

      {/* Tab Panels */}
      {activeTab === "contacts" ? <ContactTab /> : <GroupTab />}
    </div>
  );
}

export { ContactTab, GroupTab };
